import { ApolloError } from '@apollo/client';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import React from 'react';

import { isThisError } from 'lane-shared/helpers';
import { InvalidDaysAheadError } from 'activate-errors';
import ErrorMessage from 'components/general/ErrorMessage';

interface UsePMScheduleErrorHandlerOptions {
  errorPath?: string;
  failureToastKey: string;
}

export function usePMScheduleErrorHandler({
  errorPath,
  failureToastKey,
}: UsePMScheduleErrorHandlerOptions) {
  const { t } = useTranslation();
  const history = useHistory();

  const handleError = (error: ApolloError) => {
    const graphQLError = error?.graphQLErrors?.[0];
    const exception = graphQLError?.extensions?.exception;
    const isDaysAheadError = exception
      ? isThisError(exception, InvalidDaysAheadError)
      : false;

    let toastMessage: string;

    if (isDaysAheadError) {
      toastMessage = t(
        'web.admin.workOrder.preventiveMaintenance.schedule.message.daysAheadError'
      );
    } else {
      if (errorPath) {
        history.push(errorPath);
      }

      toastMessage = t(failureToastKey);
    }

    window.Toast.show(<ErrorMessage error={toastMessage} />);
  };

  return { handleError };
}

